import React from 'react';

const HowItWorksCard = ({ id, image, title, description }) => {
   return (
      <div className="w-full relative">
         <div className="rounded-lg text-center pt-8 sm:pt-10 md:pt-12 pb-6 sm:pb-8 md:pb-10 px-4 sm:px-6 md:px-8 h-full bg-white dark:bg-dark-5">
            <div className="flex justify-center">
               <img src={image} alt={title} className="h-16 sm:h-18 md:h-20 w-auto dark:invert dark:opacity-90" />
            </div>
            <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-center justify-center mb-3">
               <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 flex justify-center items-center rounded-full bg-dark-1 mb-2 sm:mb-0">
                  <span className="text-subtitle font-medium text-white">{id}</span>
               </div>
               <div className='flex items-center sm:ml-3 md:ml-4 justify-center'>
                  <h5 className="text-sm sm:text-base md:text-subtitle flex text-dark-1 dark:text-white font-semibold text-center sm:text-left">
                     {title}
                  </h5>
               </div>
            </div>
            <p className="text-normal sm:text-sm text-gray-600 dark:text-gray-300 text-center px-1 sm:px-0">{description}</p>
         </div>
      </div>
   );
};

export default HowItWorksCard;